import React, { useRef, useState, useEffect } from 'react';
import { IDropDownList } from './index';
import RMSvgIcon from '../RMSvgIcon';

interface Props {
  item: IDropDownList;
  setShowDropDownList: (show: boolean) => void;
}

export function RMDropDownSubMenuItem({ item, setShowDropDownList }: Props) {
  const [open, setOpen] = useState(false);
  const [openLeft, setOpenLeft] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const subMenuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open || !subMenuRef.current || !containerRef.current) {
      return;
    }

    const subMenuRect = subMenuRef.current.getBoundingClientRect();
    const willOverflowRight = subMenuRect.right > window.innerWidth;
    const willOverflowLeft = subMenuRect.left < 0;

    if (willOverflowRight && !willOverflowLeft) {
      setOpenLeft(true);
    } else {
      setOpenLeft(false);
    }
  }, [open]);

  return (
    <div
      ref={containerRef}
      className={`relative flex items-center ${
        item.isDisabled
          ? 'rm-drop-down-list-row-disabled'
          : 'rm-drop-down-list-row rm-drop-down-list-row-hover'
      } ${item.itemClass ?? ''}`}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => {
        setOpen(false);
        setOpenLeft(false);
      }}
    >
      {item.iconProps && (
        <div className="rm-drop-down-list-row-icon">
          <RMSvgIcon {...item.iconProps} />
        </div>
      )}
      {item.Icon && <div className="rm-drop-down-list-row-icon">{item.Icon}</div>}
      {item.label && (
        <div className="rm-drop-down-list-row-text flex-1">{item.label}</div>
      )}

      <span className="ml-auto pl-2 text-xs text-gray-400">▶</span>

      {open && (
        <div
          ref={subMenuRef}
          className={`
            top-0
            rm-drop-down-submenu-panel
            ${openLeft ? 'right-full' : 'left-full'}
          `}
        >
          {item.subMenu.map((subItem, subIndex) => (
            <span
              key={`sub-${subIndex}`}
              {...(subItem?.titleTip && { title: subItem.titleTip })}
            >
              <div
                className={`
                  rm-drop-down-submenu-row
                  ${
                    subItem.isDisabled
                      ? 'rm-drop-down-list-row-disabled'
                      : subItem.onClick
                      ? 'rm-drop-down-list-row rm-drop-down-list-row-hover'
                      : 'rm-drop-down-list-row'
                  }
                  ${subItem.itemClass ?? ''}
                  ${
                    subItem.addSeparator
                      ? 'border-solid border-0 border-b border-b-[#E0E0E0]'
                      : ''
                  }
                `}
                onClick={(e) => {
                  if (!subItem.isDisabled && subItem.onClick) {
                    subItem.onClick(e);
                    setOpen(false);
                    setShowDropDownList(false); // close the whole menu too
                  }
                }}
              >
                {subItem.iconProps && (
                  <div className="rm-drop-down-list-row-icon">
                    <RMSvgIcon {...subItem.iconProps} />
                  </div>
                )}
                {subItem.Icon && (
                  <div className="rm-drop-down-list-row-icon">{subItem.Icon}</div>
                )}
                {subItem.label && (
                  <div className="rm-multilevel-drop-down-list-row-text">
                    {subItem.label}
                  </div>
                )}
              </div>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
